import React from "react";  
import { 
  FaHotel, 
  FaConciergeBell, 
  FaUtensils, 
  FaSpa, 
  FaUsers, 
  FaBed,
  FaArrowRight,
  FaCheck,
} from "react-icons/fa";
import { MdRoomService } from "react-icons/md";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChallengesImage from "../assets/hospitality-challenges.jpeg"; 
import heroBg from "../assets/Hospitality.jpg"; 


const HospitalityIndustry = () => {
  const services = [
  {
    icon: FaHotel,
    title: "Hotel Management",
    description:
      "Comprehensive hotel operations and management services for smooth daily functioning",
    features: [
      "Front Office Operations",
      "Housekeeping Management",
      "Booking Control",
      "Guest Experience",
    ],
    color: "from-blue-500 to-cyan-500",
    iconColor: "text-white",
  },
  {
    icon: MdRoomService,
    title: "Room Services",
    description:
      "Premium in-room dining and hospitality services for guest satisfaction",
    features: [
      "24/7 Room Service",
      "Customized Dining",
      "Fast Delivery",
      "Service Tracking",
    ],
    color: "from-purple-500 to-fuchsia-500",
    iconColor: "text-white",
  },
  {
    icon: FaUtensils,
    title: "Food & Beverage",
    description:
      "End-to-end restaurant, catering, and food service management",
    features: [
      "Restaurant Management",
      "Banquet Services",
      "Catering Solutions",
      "Menu Engineering",
    ],
    color: "from-orange-500 to-amber-500",
    iconColor: "text-white",
  },
  {
    icon: FaConciergeBell,
    title: "Guest Experience",
    description:
      "Personalized guest interactions for memorable hospitality experiences",
    features: [
      "Concierge Services",
      "Personalized Stays",
      "Feedback Management",
      "Luxury Experiences",
    ],
    color: "from-green-500 to-emerald-500",
    iconColor: "text-white",
  },
  {
    icon: FaSpa,
    title: "Wellness & Spa",
    description:
      "Luxury wellness solutions for resort and hotel spa services",
    features: [
      "Spa Operations",
      "Wellness Programs",
      "Therapy Management",
      "Premium Treatments",
    ],
    color: "from-red-500 to-rose-500",
    iconColor: "text-white",
  },
  {
    icon: FaBed,
    title: "Accommodation Services",
    description:
      "Comfort-driven accommodation solutions for all guest segments",
    features: [
      "Luxury Rooms",
      "Budget Stays",
      "Suite Management",
      "Housekeeping Support",
    ],
    color: "from-teal-500 to-cyan-500",
    iconColor: "text-white",
  },
];

  const segments = [
  {
    category: "Hospitality Services",
    items: [
      "Hotel Management",
      "Resort Operations",
      "Food & Beverage",
      "Guest Relations",
      "Spa & Wellness",
      "Housekeeping",
      "Room Services",
      "Concierge Support",
    ],
    icon: FaHotel,
    iconColor: "text-white",
  },
  {
    category: "Hospitality Segments",
    items: [
      "Luxury Hotels",
      "Budget Hotels",
      "Resorts",
      "Serviced Apartments",
      "Boutique Hotels",
      "Banquet Halls",
      "Convention Centers",
      "Cruise Hospitality",
    ],
    icon: FaUsers,
    iconColor: "text-white",
  },
  {
    category: "Operational Support",
    items: [
      "Staff Training",
      "Inventory Management",
      "Customer Feedback",
      "Revenue Management",
      "Digital Bookings",
      "Marketing Support",
      "Quality Control",
      "Service Automation",
    ],
    icon: FaConciergeBell,
    iconColor: "text-white",
  },
];

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100">
      <Navbar />
      <div className="min-h-screen">

{/* HERO SECTION */}
<div
  className="relative bg-cover bg-center bg-no-repeat text-white py-24 overflow-hidden"
  style={{ backgroundImage: `url(${heroBg})` }}
>
  <div className="absolute inset-0 bg-black/60"></div>

  <div className="container mx-auto px-6 relative z-10 text-center">

    <h1 className="text-6xl font-bold text-white mb-6 pb-3">
      Hospitality Industry
    </h1>

    <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
      Delivering exceptional guest experiences with world-class hospitality solutions.
    </p>
  </div>
</div>

{/* SERVICES SECTION */}
<div className="pt-10 pb-20 bg-gradient-to-br from-gray-900 to-black text-white relative">
  <div className="container mx-auto px-6 relative">
    <div className="text-center mb-16">
      <h2 className="text-5xl font-bold text-white mb-6">
        Hospitality Services
      </h2>
      <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
        Premium hospitality solutions for hotels, resorts, and luxury stays
      </p>
    </div>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {services.map((service, index) => (
        <div
          key={index}
          className="group bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-700 hover:border-blue-500/50 hover:-translate-y-2"
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-3 rounded-2xl shadow-lg flex items-center justify-center">
              <service.icon className={`text-2xl ${service.iconColor}`} />
            </div>
            <h3 className="text-2xl font-bold">{service.title}</h3>
          </div>

          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            {service.description}
          </p>

          <div className="space-y-3">
            {service.features.map((feature, i) => (
              <div key={i} className="flex items-center">
                <div className="bg-cyan-300/20 p-1 rounded-lg mr-3">
                  <FaCheck className="text-blue-400 text-sm" />
                </div>
                <span className="text-gray-300">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

{/* CHALLENGES SECTION */}
<div className="pt-10 pb-20 bg-white">
  <div className="container mx-auto px-6">
    <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
      Challenges Faced by the Hospitality Industry
    </h2>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

        <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6">
          <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">01</div>
          <h3 className="font-bold text-gray-900 mb-2">Seasonal Demand Fluctuations</h3>
          <p className="text-gray-600">Dynamic pricing and marketing stabilize occupancy.</p>
        </div>

        <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6">
          <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">02</div>
          <h3 className="font-bold text-gray-900 mb-2">High Operational Costs</h3>
          <p className="text-gray-600">Automation reduces repetitive service expenses.</p>
        </div>

        <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6">
          <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">03</div>
          <h3 className="font-bold text-gray-900 mb-2">Staff Management</h3>
          <p className="text-gray-600">Digital workforce systems improve efficiency.</p>
        </div>

        <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6">
          <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">04</div>
          <h3 className="font-bold text-gray-900 mb-2">Guest Retention</h3>
          <p className="text-gray-600">Personalized services boost repeat stays.</p>
        </div>

      </div>

      <div className="flex justify-center">
        <img src={ChallengesImage} alt="Challenges" className="rounded-3xl shadow-2xl w-full max-w-xl object-cover" />
      </div>

    </div>
  </div>
</div>

{/* 🌟 AMPLINOVA OPPORTUNITIES SECTION */}
<div className="pt-10 pb-20 bg-white">
  <div className="container mx-auto px-6">
    <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
      How <span className="bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent underline decoration-blue-400 decoration-4">Amplinova</span> turns Hospitality challenges into opportunity
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
          <FaCheck className="text-white text-3xl" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Digital Guest Experience</h3>
        <p className="text-gray-600 leading-relaxed">AI-powered services improve satisfaction and efficiency.</p>
      </div>

      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
          <FaCheck className="text-white text-3xl" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Smart Revenue Management</h3>
        <p className="text-gray-600 leading-relaxed">Automated pricing maximizes profitability.</p>
      </div>

      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
          <FaCheck className="text-white text-3xl" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Guest Loyalty Systems</h3>
        <p className="text-gray-600 leading-relaxed">Reward programs increase lifetime customer value.</p>
      </div>

      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
          <FaCheck className="text-white text-3xl" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Scalable Growth</h3>
        <p className="text-gray-600 leading-relaxed">Cloud systems support expansion across locations.</p>
      </div>

    </div>
  </div>
</div>

{/* SEGMENTS SECTION */}
<div className="pt-10 pb-20 bg-white relative">
  <div className="container mx-auto px-6 relative">
    <div className="text-center mb-16">
      <h2 className="text-5xl font-bold text-gray-900 mb-6">
        Hospitality Segments We Serve
      </h2>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto">
        Comprehensive hospitality coverage across all service formats
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-8">
      {segments.map((segment, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl p-8 shadow-lg border border-blue-100"
        >
          <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-4 rounded-2xl inline-flex mb-6 shadow-lg">
            <segment.icon className={`text-2xl ${segment.iconColor}`} />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            {segment.category}
          </h3>
          <div className="space-y-3">
            {segment.items.map((item, itemIndex) => (
              <div key={itemIndex} className="flex items-center text-gray-700">
                <div className="bg-green-100 p-1 rounded-lg mr-3">
                  <FaCheck className="text-green-600 text-sm" />
                </div>
                {item}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

{/* CTA SECTION */}
<div className="relative pt-10 pb-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
  <div className="absolute inset-0 bg-black opacity-40"></div>

  <div className="container mx-auto px-6 text-center relative z-10">
    <h2 className="text-5xl font-bold text-white mb-8">
      Ready to Elevate Your Hospitality Business?
    </h2>
    <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
      Boost occupancy, optimize operations, and deliver unforgettable guest experiences.
    </p>

    <button
      onClick={() => (window.location.href = "/contact-us")}
      className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-12 py-5 rounded-xl font-semibold hover:scale-105 transition flex items-center gap-3 mx-auto">
      Get Started Now
      <FaArrowRight />
    </button>
  </div>
</div>

</div>
<Footer />
</div>
);
};

export default HospitalityIndustry;
